<customer-portal-app-navbar></customer-portal-app-navbar>
<customer-portal-app-navbar-second></customer-portal-app-navbar-second>
<customer-portal-app-does-not-have></customer-portal-app-does-not-have>
<customer-portal-footer-container></customer-portal-footer-container>
